import { PropAppParamV3Schema, PropFormikField } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import Select, { Creatable } from "react-select";
import { arrayToSelectOptions, STYLES } from "util/select";

function handleChangeMulti(handler, opts) {
  const values = opts ? opts.map((opt) => opt.value) : null;
  return handler(values);
}

function handleChangeSingle(handler, opt) {
  const value = opt ? opt.value : null;
  return handler(value);
}

function getSelectValue(rawValue, isMulti) {
  if (rawValue === null || rawValue === undefined) {
    return null;
  }

  const isArray = Array.isArray(rawValue);
  let value = isArray ? rawValue : [rawValue];

  // Multi value selects should always be arrays
  if (isMulti) {
    return arrayToSelectOptions(value);
  }

  // Single value selects should always be single strings or null
  return arrayToSelectOptions(value)[0] || null;
}

function SelectField(props) {
  const { field, handleChange, isMulti, readOnly, schema } = props;
  const { is_creatable: isCreatable, options: schemaOptions } = schema;

  const options = arrayToSelectOptions(schemaOptions || []);
  const commonProps = {
    isMulti,
    options,
    name: field.name,
    isDisabled: readOnly,
    styles: STYLES,
  };

  const SelectComponent = isCreatable ? Creatable : Select;
  const selectValue = getSelectValue(field.value, isMulti);

  const onChangeHandler = isMulti
    ? handleChangeMulti.bind(null, handleChange)
    : handleChangeSingle.bind(null, handleChange);

  return (
    <SelectComponent
      isClearable
      onChange={onChangeHandler}
      value={selectValue}
      {...commonProps}
    />
  );
}

SelectField.propTypes = {
  field: PropFormikField.isRequired,
  handleChange: PropTypes.func.isRequired,
  isMulti: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  schema: PropAppParamV3Schema.isRequired,
};

export { SelectField };
